import React, { Component } from "react";
import Loader from "../../general/Loader";
import { formatCurrency } from "../../../utils/helpers";
import Pagination from "../../general/Pagination";
import { withRequest } from "../../../utils/request";
import dayjs from "dayjs";
import { debounce } from "lodash";

const queryDeFiltros = (filtros) =>
    Object.keys(filtros)
        .map((fil) => `${fil}=${filtros[fil]}`)
        .join("&");

class Gastos extends Component {
    state = {
        gastos: [],
        meta: false,
        links: false,
        loading: true,
        filtrosQuery: "",
        filtros: [],
    };
    componentDidMount() {
        this.getGastos();
    }
    getGastos = async (url = null) => {
        const id = this.props.item.id;
        url = url ? url : `gastos-internos?item=${id}&limit=20`;
        const gastos = await this.props.request(url);

        if (gastos.data && gastos.data.length > 0) {
            this.setState({
                gastos: gastos.data,
                meta: gastos.meta,
                links: gastos.links,
                loading: false,
            });
        }

        this.setState({ loading: false });
    };

    // `await this.setState()` no espera al re-render: setState no devuelve una
    // promesa, así que la continuación se reanudaba antes de que React
    // aplicara el update y `this.state.filtros` tenía los filtros anteriores.
    // Por eso cada consulta salía un filtro atrás y el primer intento no
    // filtraba nada. El estado se actualiza con la forma funcional y la consulta
    // se lanza en el callback de setState, que sí corre después del commit.
    onFiltroChange = (value, filtro) => {
        this.setState((state) => {
            const filtros = { ...state.filtros, [filtro]: value };

            return { filtros };
        }, this.buscarConFiltros);
    };
    // El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
    // era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
    // descartaba el primero junto con su valor.
    buscarConFiltros = debounce(() => {
        this.getGastosFiltrados();
    }, 500);

    getGastosFiltrados = () => {
        const query = queryDeFiltros(this.state.filtros);

        this.setState({ filtrosQuery: `?${query}` });

        this.getGastos("gastos-internos?limit=20&" + query);
    };

    render() {
        const { gastos, meta, links } = this.state;
        const { item } = this.props;
        const { loading } = this.state;

        if (loading === true) {
            return <Loader />;
        }

        const gastosItems = gastos.reduce((acc, curr) => {
            const items = curr.items.filter(i => i.item?.id === item.id).map(i => {
                return {
                    ...i,
                    empleado: curr.empleado,
                    vehiculo: curr.vehiculo,
                    cuenta: curr.cuenta,
                    categorias: curr.categorias,
                    suplidor: curr.suplidor,
                    ruta: curr.ruta,
                }
            });
            return [...acc, ...items];
        }, []);

        console.log(gastosItems);

        return (
            <div>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col-md-6'>
                                <label htmlFor='desde'>Desde</label>
                                <input
                                    type='date'
                                    name='desde'
                                    id='desde'
                                    defaultValue={dayjs()
                                        .startOf("day")
                                        .format("YYYY-MM-DD")}
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "desde"
                                        )
                                    }
                                />
                            </div>
                            <div className='col-md-6'>
                                <label htmlFor='hasta'>Hasta</label>
                                <input
                                    type='date'
                                    name='hasta'
                                    id='hasta'
                                    defaultValue={dayjs()
                                        .endOf("day")
                                        .format("YYYY-MM-DD")}
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "hasta"
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {gastos.length > 0 ? (
                    <table className='table tickets-table'>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Descripción</th>
                                <th>Vehículo</th>
                                <th>Empleado</th>
                                <th>Cantidad</th>
                                <th className="text-right">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gastosItems.map(gasto => (
                                <tr key={gasto.id}>
                                    <td>{gasto.fecha}</td>
                                    <td>{gasto.suplidor?.nombre}</td>
                                    <td>{gasto.vehiculo?.ficha}</td>
                                    <td>{gasto.empleado?.ficha}</td>
                                    <td>{gasto.cantidad} {gasto.item?.unidad}</td>
                                    <td className="text-right">{formatCurrency(gasto.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div>No se han registrado gastos de este item.</div>
                )}
                {meta && (
                    <Pagination
                        links={links}
                        meta={meta}
                        getData={this.getGastos}
                    />
                )}
            </div>
        );
    }
}

export default withRequest(Gastos);
